const useCloudinary = (imgUrl, styles) => {
  if (!imgUrl) return '';
  if (imgUrl.includes('/media/')) return imgUrl;

  if (imgUrl.includes('/upload/')) {
    const [baseUrl, uploadPath] = imgUrl.split('/upload/');
    return `${baseUrl}/upload/${styles}/${uploadPath}`;
  }

  if (imgUrl.includes('/image/')) {
    const [baseUrl, imagePath] = imgUrl.split('/image/');
    return `${baseUrl}/upload/${styles}/${imagePath}`;
  }

  return imgUrl;
};

export default useCloudinary;
